module.exports = __webpack_public_path__ + "img/stamp-redeemed.5399721b.png";